import { Dialog } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

import { BrowserApiService } from '@core/common';

import { LoginDialog } from '../../dialogs/login/login.dialog';

@Component({
  selector: 'ui-login-button',
  imports: [NgClass],
  templateUrl: './login-button.component.html',
  styleUrl: './login-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginButtonComponent implements OnInit {
  private readonly dialog = inject(Dialog);
  private readonly router = inject(Router);
  private readonly browser = inject(BrowserApiService);

  @Input()
  public classList = 'button button_login';

  @Input()
  public title = $localize`:@@login_button.title:Авторизация`;

  @Input()
  public disabled = false;

  @Input()
  public icon = 'icon icon_new icon_lock';

  @Input()
  public hasIcon = true;

  @Input()
  public allowDialogAutoOpen = false;

  @Input()
  public redirectToMain = false;

  ngOnInit(): void {
    if (!this.allowDialogAutoOpen || !this.router.url.includes('open_auth') || this.browser.isServer()) {
      return;
    }

    setTimeout(() => this.openLoginDialog(), 300);
  }

  openLoginDialog(): void {
    this.dialog.open(LoginDialog, {
      data: { redirectToMain: this.redirectToMain }
    });
  }
}
